import { useQuery } from '@tanstack/react-query';
import { eventService } from '../services/eventService';
import { Event, InglesParanaKids, INITIAL_EVENT } from '../types/events.types';

interface UseEventsReturn {
  events: Event[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

const FALLBACK_EVENTS: Event[] = [INITIAL_EVENT];

export const useEvents = (keyValueUi?: string): UseEventsReturn => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['eventos', keyValueUi],
    queryFn: () => eventService.buscarEventos(keyValueUi ?? ''),
    enabled: !!keyValueUi,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return {
    events: data ?? FALLBACK_EVENTS,
    isLoading,
    error: isError ? (error as Error) : null,
    refetch,
  };
};

interface UseInglesParanaKidsReturn {
  student: InglesParanaKids | null;
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useInglesParanaKids = (): UseInglesParanaKidsReturn => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ['ingles-parana-kids'],
    queryFn: () => eventService.buscarDadosEstudanteInglesParanaKids(),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return {
    student: data ?? null,
    isLoading,
    error: isError ? (error as Error) : null,
    refetch,
  };
};

export function useStatusPesquisa() {
  return useQuery({
    queryKey: ['inglespr', 'dashboard'],
    queryFn: ({ signal }) => eventService.getStatusPesquisa(signal),
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });
}

// import { useQuery } from '@tanstack/react-query';
// import { eventService } from '../services/eventService';
// import { Event, INITIAL_EVENT } from '../types/events.types';

// interface UseEventsReturn {
//   events: Event[];
//   isLoading: boolean;
//   error: Error | null;
//   refetch: () => void;
// }

// export const useEvents = (keyValueUi?: string): UseEventsReturn => {
//   // const { startLoading, stopLoading } = useLoading();

//   const {
//     data: eventData,
//     isLoading,
//     isError,
//     error,
//     refetch,
//   } = useQuery({
//     queryKey: ['eventos', keyValueUi],
//     queryFn: async () => {
//       if (!keyValueUi) {
//         throw new Error('keyValueUi é obrigatório');
//       }
//       return eventService.buscarEventos(keyValueUi);
//     },
//     enabled: !!keyValueUi,
//     staleTime: 10 * 60 * 1000,
//     refetchOnWindowFocus: false,
//     retry: false,
//   });

//   // Sincroniza com LoadingContext
//   // useEffect(() => {
//   //   if (isLoading) {
//   //     startLoading();
//   //   } else {
//   //     stopLoading();
//   //   }
//   // }, [isLoading, startLoading, stopLoading]);

//   // ✅ CORRETO - eventData já é Event[], não precisa envolver em array
//   const events: Event[] = eventData ?? [INITIAL_EVENT];

//   return {
//     events,
//     isLoading,
//     error: isError ? (error as Error) : null,
//     refetch,
//   };
// };
